export default __webpack_public_path__ + "static/media/Chair Bunny.1301229c.png";